import { Box, styled } from '@mui/material'
import { SvgImage } from 'components/ui'
import { useEffect, useState } from 'react'
import { APIs } from 'services'

interface ICloudPay {
  account: string
  onClose: () => void
}

export const CloudPay = ({ account, onClose }: ICloudPay): JSX.Element => {
  const [visible, setVisible] = useState<boolean>(false)
  const [iframeUrl, setIframeUrl] = useState<string>('')

  useEffect(() => {
    const cloudPay = async (): Promise<void> => {
      try {
        const cloudData = await APIs.getCloudData({ accountNumber: account })
        if (cloudData.data?.Data?.CloudPaymentURL) {
          setIframeUrl(cloudData.data?.Data?.CloudPaymentURL)
          setVisible(true)
        }
      } catch (e) { }
    }

    cloudPay()
  }, [account])

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [visible])

  const handleHide = (): void => {
    setVisible(false)
    onClose()
  }

  return (
    <Box>
      <ICModal visible={visible ? 'true' : 'false'}>
        <ICModalContent>
          <CloseButton onClick={handleHide}>
            <SvgImage name="CloseIcon" width={24} height={24} />
          </CloseButton>

          <IframeContainer>
            <iframe
              src={iframeUrl}
              width="100%"
              height="100%"
              allow="payment https://www.invoicecloud.com"
              title="Cloud Pay"
              style={{ border: 'none' }}
            />
          </IframeContainer>
        </ICModalContent>
      </ICModal>
    </Box>
  )
}

export const ICModal = styled(Box)<{ visible: string }>(({ visible }) => ({
  position: 'fixed',
  left: 0,
  zIndex: 999,
  top: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  opacity: visible === 'true' ? 1 : 0,
  visibility: visible === 'true' ? 'visible' : 'hidden',
  transform: visible === 'true' ? 'scale(1)' : 'scale(1.1)',
  transition: 'visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
  boxSizing: 'border-box',

  '@media (max-width: 768px)': {
    padding: '0.5rem'
  }
}))

export const ICModalContent = styled(Box)(() => ({
  backgroundColor: 'white',
  borderRadius: '0.5rem',
  width: '100%',
  height: '100%',
  maxWidth: '1000px',
  maxHeight: '800px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',

  '@media (max-width: 768px)': {
    borderRadius: '0',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100vh',
    width: '100vw'
  },

  '@media (min-width: 769px)': {
    width: '90vw',
    height: '85vh'
  }
}))

export const CloseButton = styled(Box)({
  alignSelf: 'flex-end',
  width: '2rem',
  height: '2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  borderRadius: '0.25rem',
  backgroundColor: '#f5f5f5',
  margin: '0.75rem',
  flexShrink: 0,
  transition: 'background-color 0.2s ease',

  '&:hover': {
    backgroundColor: '#e0e0e0'
  },

  '@media (max-width: 768px)': {
    margin: '0.5rem',
    width: '1.75rem',
    height: '1.75rem'
  }
})

export const IframeContainer = styled(Box)({
  flex: 1,
  width: '100%',
  padding: '0 0.75rem 0.75rem',
  boxSizing: 'border-box',

  '@media (max-width: 768px)': {
    padding: '0 0.5rem 0.5rem'
  }
})
